import { render } from "./helm.cattle.io.projecthelmchart.vue?vue&type=template&id=66973256&scoped=true"
import script from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"
export * from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"

import "./helm.cattle.io.projecthelmchart.vue?vue&type=style&index=0&id=66973256&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66973256"]])

export default __exports__